import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-7">
            {" "}
            <img src="img/IMG4.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-5">
            <div className="about-text">
              <h2>Uma Igreja Protestante</h2>
              {/* <p>{props.data ? props.data.paragraph : "loading..."}</p> */}

              <div className="list-style">
                <div className="">
                  <p>
                    A Igreja Presbiteriana da Serraria é uma comunidade
                    cristã protestante, herdeira da tradição Reformada.
                    <br />
                    <br />
                    Isto significa que nossas origens remontam ao movimento da
                    Reforma Protestante do séc. XVI mais particularmente aquele
                    movimento que foi liderado pelo teólogo francês João Calvino.
                    <br />
                    <br />
                    Estamos comprometidos com as cinco declarações clássicas do
                    movimento protestante do séc. XVI.
                    <br />
                    <br />
                    Somente a Escritura, Somente a Fé, Somente a Graça, Somente Cristo, Somente a Deus seja dada a Glória.
                  </p>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
